import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { RoleTypes } from "../../Generated/orval-apis/cit.schemas";
import { IAccessCodes } from "../../Common/Sidemenus";

interface Department {
  id: string;
  name: string;
}

interface UserState {
  token: string;
  name: string;
  tokenExpiry: number;
  id: string;
  role: string;
  email: string;
  userName: string;
  status: number;
  roles: string[];
  roleType: RoleTypes;
  rights: IAccessCodes | null;
  isDefaultPassword:boolean;
  userImage:any;
  departments:Department[];
  StudentDetails:any;
  requiresTwoFactor:boolean;
  isFirst2FASuggestion:boolean;
}

const initialState: UserState = {
  token: "",
  name: "",
  tokenExpiry: 0,
  id: "",
  role: "",
  email: "",
  userName: "",
  status: 0,
  roles: [],
  roleType:RoleTypes.Undefined,
  rights: null,
  isDefaultPassword:false,
  userImage:null,
  departments:[],
  StudentDetails:null,
  requiresTwoFactor:false,
  isFirst2FASuggestion:false
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.token = action.payload.token;
      state.name = action.payload.name;
      state.tokenExpiry = action.payload.tokenExpiry;
      state.id = action.payload.id;
      state.role = action.payload.role;
      state.email = action.payload.email;
      state.userName = action.payload.userName;
      state.status = action.payload.status;
      state.roles = action.payload.roles;
      state.roleType=action.payload.roleType;
      state.isDefaultPassword=action?.payload?.isDefaultPassword || false;
      state.rights = action.payload.rights;
      state.departments = action?.payload?.departments || [];
      state.userImage = action.payload?.userImage ? action.payload?.userImage : null;
      state.StudentDetails= action.payload?.studentDetails || null;
      state.requiresTwoFactor=action.payload?.requiresTwoFactor || null;
      state.isFirst2FASuggestion=action?.payload?.isFirst2FASuggestion || false;
    },
    setTwoFactorStatus: (state, action) => {
      state.requiresTwoFactor = action.payload;
    },
    resetUserData: (state) => {
      Object.assign(state,initialState)
    },
  },
});

export const { setUserData, setTwoFactorStatus,resetUserData } = userSlice.actions;
export const userData = (state: RootState) => state.user;
export const isDefaultPassword = (state: RootState) => state?.user?.isDefaultPassword|| false;
export const isFirst2FASuggestion = (state: RootState) => state?.user?.isFirst2FASuggestion|| false;
export const userIsAuthenticated = (state: RootState): boolean => {
  const user = state?.user;
  if (!user) return false;
  return Boolean(user?.id);
};
export default userSlice.reducer;
